import React , {useContext, useEffect} from 'react';
import clsx from 'clsx';
import { ServiceDialog, CancelButton, ConfirmButton } from '../../../styling/Styles';
import { createJavascriptPerPage } from '../../DeployPage/ExportProjectCode';
import AuthContext from '../../AppAuthContext';
import ErrorDisplayUi from '../../BuildApps/Spinners/ErrorDisplayUi';
import { apiService } from '../../../services';
import ExportProjectCodeViolationsPopUp from '../../GeneralComponents/ExportProjectCodeViolationsPopUp';

const GithubRepoPopUp = (props) => {

    const{
        open,
        setOpen,
        setLoadGithubAnalyticsSpinner,
        setMetricsData,
        state,
        cause
    }= props;

    const { dispatch } = useContext(AuthContext);
    const [displayWentWrongUi, setDisplayWentWrongUi] = React.useState(false);
    const [stateFinishPushToGithub, setStateFinishPushGithub] = React.useState(true);
    const [openExportProjectCodePopUp, setOpenExportProjectCodePopUp] = React.useState(false);
    const [violationMessage, setViolationMessage] = React.useState('');
  
    useEffect( () => {

        if(stateFinishPushToGithub === false && openExportProjectCodePopUp === false){

            const selectedProject = JSON.parse(localStorage.getItem('selectedProject'))
            let repoName = '';
            const { owner } = JSON.parse(localStorage.getItem('data'))[selectedProject];
            if(state.reason === 'server'){
                repoName = `${owner}-server-${JSON.parse(localStorage.getItem('data'))[selectedProject].name}`;
            }
            else if (state.reason === 'front'){
                repoName = `${owner}-frontEnd-${JSON.parse(localStorage.getItem('data'))[selectedProject].name}`;
            }

            setTimeout( () => {
                apiService
                .analyzeProject(repoName)
                .then((data) => {
                    if(data.data.error !== undefined){
                        setLoadGithubAnalyticsSpinner(false);
                        setDisplayWentWrongUi(true);
                    }
                    else{
                        setMetricsData(data.data)
                        setLoadGithubAnalyticsSpinner(false);
                    }
                })
                .catch( err => {
                    setLoadGithubAnalyticsSpinner(false);
                    throw err;
                }) 
                }, 5000
            )

            setStateFinishPushGithub(true);
            
        }
        
    },[stateFinishPushToGithub])

    useEffect( () => {

        if(openExportProjectCodePopUp === true){
            setLoadGithubAnalyticsSpinner(false);
            setStateFinishPushGithub(true);
        }

    },[openExportProjectCodePopUp])

    const handleClose = () => {
        setOpen(false);
    }

    const handleConfirm = async () => {
        setOpen(false);
        const reason = 'AnalyzeProject';
        setLoadGithubAnalyticsSpinner(true);
        createJavascriptPerPage(setStateFinishPushGithub, dispatch, setDisplayWentWrongUi, reason,setViolationMessage,setOpenExportProjectCodePopUp);
    }

    return(
        <>
            <ServiceDialog
                open={open}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            > 
                 <div className={clsx('titlePopUp','paddingTitle')}> 
                    {cause === 'empty' ?
                        <span> Github repo not found</span>
                        :
                        <span> Unsynced repo </span>
                    }
                    <div onClick={handleClose} aria-hidden="true" className={clsx('pop-up-close-btn')}>x</div>
                </div>
                 <div className ='paddingTitle'>
                    
                    
                        <div className={clsx('spacingTopDiv')} style={{display: 'flex',flexDirection: 'column', justifyContent: 'center'}}>
                            {   
                                 cause === 'empty' ?
                                    <span>In order to view the quality metrics for your project, you need to first push your project to GitHub.</span>
                                :
                                    <span>The created Github repo is not synced with the latest changes.</span>
                            }
                            <span style={{alignSelf: 'center'}}>Do you want to push your project to Github now?</span>
                        </div>
                    
                    <div  
                        style={{
                            justifyContent:'space-between',
                            display: 'flex',
                            flexDirection: 'row', 
                            marginTop: '2vw',
                        }}

                    >
                        <div >
                            <CancelButton onClick={handleClose}>
                                Cancel
                            </CancelButton>
                        </div>
                        <div className={clsx('flexRowDirection')}>
                            <ConfirmButton onClick={handleConfirm}>
                                Push
                            </ConfirmButton>
                        </div>
                    </div>
                </div>

            </ServiceDialog>
            <ExportProjectCodeViolationsPopUp
                open={openExportProjectCodePopUp}
                setOpen={setOpenExportProjectCodePopUp}
                title={violationMessage}
            />
            <ErrorDisplayUi
                displayWentWrongUi={displayWentWrongUi}
                setDisplayWentWrongUi={setDisplayWentWrongUi}
            />
        </>
    )

}

export default GithubRepoPopUp;
